module.exports = __webpack_public_path__ + "9d139b9e57f11cf4ff3154e64453036f.svg";